// Lib
import React from "react";
import classes from "./Spinner.module.css"

const Spinner = () => <div className={classes.loader}>Loading...</div>

export default Spinner;